import React from "react";
import { Users, ShieldCheck, HardHat } from "lucide-react";
import { services } from "../mock";

const iconMap = { Users, ShieldCheck, HardHat };

const dashesSvg = (
  <svg
    viewBox="0 0 80 120"
    className="absolute -right-10 md:-right-16 top-0 w-16 md:w-20 h-auto pointer-events-none"
    aria-hidden="true"
  >
    <line x1="10" y1="10" x2="60" y2="10" stroke="#2D6A4F" strokeWidth="4" strokeLinecap="round" />
    <line x1="20" y1="50" x2="65" y2="50" stroke="white" strokeWidth="4" strokeLinecap="round" />
    <line x1="15" y1="90" x2="55" y2="90" stroke="white" strokeWidth="4" strokeLinecap="round" />
  </svg>
);

const ServiceCard = ({ service }) => {
  const Icon = iconMap[service.icon];
  return (
    <div className="group bg-white rounded-3xl p-8 md:p-10 transition-all hover:shadow-2xl hover:-translate-y-1 duration-300">
      <div className="w-14 h-14 bg-[#2D6A4F] rounded-2xl flex items-center justify-center mb-8">
        <Icon className="w-7 h-7 text-white" strokeWidth={2} />
      </div>
      <h3
        className="text-[26px] md:text-[28px] font-semibold text-[#0E0E10] mb-4 tracking-tight"
        style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
      >
        {service.title}
      </h3>
      <p className="text-[15px] md:text-[16px] text-[#4A4A4D] leading-relaxed">
        {service.description}
      </p>
    </div>
  );
};

const Services = () => {
  return (
    <section
      id="solutions"
      className="bg-[#0E0E10] text-white py-20 md:py-28 px-4 md:px-8"
    >
      <div className="max-w-[1300px] mx-auto">
        <div className="flex justify-center mb-7">
          <div className="inline-flex items-center gap-2 bg-[#2D6A4F] text-white px-4 py-1.5 rounded-full text-sm font-semibold">
            <span>👷🏽</span>
            Why work with eebssolutions?
          </div>
        </div>

        <div className="relative max-w-[900px] mx-auto mb-14 md:mb-20">
          <h2
            className="text-center text-[36px] md:text-[52px] leading-[1.1] font-semibold tracking-tight"
            style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            eebssolutions have kept their construction clients{" "}
            <span className="italic font-normal">compliant</span> for over{" "}
            <span className="italic font-normal">23 years</span>.
            <span className="relative inline-block">{dashesSvg}</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {services.map((s, i) => (
            <ServiceCard key={i} service={s} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
